module.exports = __webpack_public_path__ + "img/icon_map_32_off_110.1131ad9c.png";